import React from 'react';
import { PanelSubTitle, PanelTitle } from './styles';

export type TitleProps = {
  title: React.ReactNode;
  subTitle?: React.ReactNode;
};

export const Title: React.FC<TitleProps> = (props) => {
  const { subTitle, title } = props;
  return (
    <PanelTitle hasSubtitle={!!subTitle}>
      {title}
      {subTitle && <PanelSubTitle>{subTitle}</PanelSubTitle>}
    </PanelTitle>
  );
};
